import React from 'react';

const HeroIllustration: React.FC = () => {
  return (
    <svg
      viewBox="0 0 800 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto"
    >
      {/* Background elements */}
      <circle cx="700" cy="100" r="80" fill="#EEF2FF" opacity="0.5" />
      <circle cx="100" cy="500" r="60" fill="#FEF3C7" opacity="0.5" />

      {/* Main Dashboard Container */}
      <rect x="100" y="80" width="600" height="440" rx="16" fill="white" stroke="#E5E7EB" strokeWidth="2" />

      {/* Dashboard Header */}
      <rect x="100" y="80" width="600" height="60" rx="16" fill="#4F46E5" />
      <text x="130" y="118" fill="white" fontSize="24" fontWeight="bold">Khata.biz Dashboard</text>

      {/* User icon in header */}
      <circle cx="650" cy="110" r="18" fill="white" opacity="0.3" />
      <circle cx="650" cy="110" r="12" fill="white" />

      {/* Stats Cards Row */}
      {/* Card 1 - Revenue */}
      <rect x="130" y="170" width="150" height="100" rx="8" fill="#EEF2FF" />
      <text x="145" y="195" fill="#4F46E5" fontSize="12" fontWeight="600">Total Revenue</text>
      <text x="145" y="235" fill="#1E40AF" fontSize="28" fontWeight="bold">₹24.5L</text>
      <text x="145" y="255" fill="#10B981" fontSize="11">↑ 12% this month</text>

      {/* Card 2 - Orders */}
      <rect x="310" y="170" width="150" height="100" rx="8" fill="#FEF3C7" />
      <text x="325" y="195" fill="#F59E0B" fontSize="12" fontWeight="600">Purchase Orders</text>
      <text x="325" y="235" fill="#D97706" fontSize="28" fontWeight="bold">1,234</text>
      <text x="325" y="255" fill="#6B7280" fontSize="11">Active orders</text>

      {/* Card 3 - Inventory */}
      <rect x="490" y="170" width="150" height="100" rx="8" fill="#DBEAFE" />
      <text x="505" y="195" fill="#3B82F6" fontSize="12" fontWeight="600">Inventory Items</text>
      <text x="505" y="235" fill="#1E40AF" fontSize="28" fontWeight="bold">5,678</text>
      <text x="505" y="255" fill="#6B7280" fontSize="11">In stock</text>

      {/* Chart Section */}
      <rect x="130" y="300" width="320" height="180" rx="8" fill="#F9FAFB" stroke="#E5E7EB" strokeWidth="1" />
      <text x="145" y="325" fill="#374151" fontSize="14" fontWeight="600">Sales Trend</text>

      {/* Bar Chart */}
      <rect x="155" y="400" width="30" height="50" rx="4" fill="#818CF8" />
      <rect x="200" y="380" width="30" height="70" rx="4" fill="#818CF8" />
      <rect x="245" y="350" width="30" height="100" rx="4" fill="#6366F1" />
      <rect x="290" y="370" width="30" height="80" rx="4" fill="#818CF8" />
      <rect x="335" y="340" width="30" height="110" rx="4" fill="#4F46E5" />
      <rect x="380" y="360" width="30" height="90" rx="4" fill="#818CF8" />

      {/* Month labels */}
      <text x="160" y="470" fill="#6B7280" fontSize="10">Jan</text>
      <text x="205" y="470" fill="#6B7280" fontSize="10">Feb</text>
      <text x="250" y="470" fill="#6B7280" fontSize="10">Mar</text>
      <text x="295" y="470" fill="#6B7280" fontSize="10">Apr</text>
      <text x="340" y="470" fill="#6B7280" fontSize="10">May</text>
      <text x="385" y="470" fill="#6B7280" fontSize="10">Jun</text>

      {/* Recent Activity List */}
      <rect x="480" y="300" width="190" height="180" rx="8" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <text x="495" y="325" fill="#374151" fontSize="14" fontWeight="600">Recent Activity</text>

      {/* Activity Item 1 */}
      <circle cx="505" cy="355" r="8" fill="#10B981" />
      <text x="520" y="360" fill="#374151" fontSize="11">New PO Created</text>
      <text x="520" y="373" fill="#9CA3AF" fontSize="9">2 min ago</text>

      {/* Activity Item 2 */}
      <circle cx="505" cy="400" r="8" fill="#F59E0B" />
      <text x="520" y="405" fill="#374151" fontSize="11">Invoice Sent</text>
      <text x="520" y="418" fill="#9CA3AF" fontSize="9">15 min ago</text>

      {/* Activity Item 3 */}
      <circle cx="505" cy="445" r="8" fill="#3B82F6" />
      <text x="520" y="450" fill="#374151" fontSize="11">Stock Updated</text>
      <text x="520" y="463" fill="#9CA3AF" fontSize="9">1 hour ago</text>

      {/* Floating Icons */}
      {/* Package icon (top right) */}
      <g transform="translate(720, 200)">
        <circle cx="0" cy="0" r="35" fill="#4F46E5" opacity="0.1" />
        <rect x="-15" y="-15" width="30" height="30" rx="4" fill="none" stroke="#4F46E5" strokeWidth="2" />
        <line x1="-15" y1="-5" x2="15" y2="-5" stroke="#4F46E5" strokeWidth="2" />
        <line x1="0" y1="-15" x2="0" y2="15" stroke="#4F46E5" strokeWidth="2" />
      </g>

      {/* Document icon (middle right) */}
      <g transform="translate(730, 350)">
        <circle cx="0" cy="0" r="30" fill="#F59E0B" opacity="0.1" />
        <rect x="-12" y="-16" width="24" height="32" rx="2" fill="none" stroke="#F59E0B" strokeWidth="2" />
        <line x1="-6" y1="-8" x2="6" y2="-8" stroke="#F59E0B" strokeWidth="1.5" />
        <line x1="-6" y1="-2" x2="6" y2="-2" stroke="#F59E0B" strokeWidth="1.5" />
        <line x1="-6" y1="4" x2="6" y2="4" stroke="#F59E0B" strokeWidth="1.5" />
      </g>

      {/* Chart icon (bottom right) */}
      <g transform="translate(710, 490)">
        <circle cx="0" cy="0" r="28" fill="#10B981" opacity="0.1" />
        <rect x="-10" y="5" width="5" height="10" rx="1" fill="#10B981" />
        <rect x="-3" y="-2" width="5" height="17" rx="1" fill="#10B981" />
        <rect x="4" y="-8" width="5" height="23" rx="1" fill="#10B981" />
      </g>

      {/* Checkmark icon (top left) */}
      <g transform="translate(50, 150)">
        <circle cx="0" cy="0" r="25" fill="#10B981" opacity="0.15" />
        <circle cx="0" cy="0" r="16" fill="none" stroke="#10B981" strokeWidth="2" />
        <path d="M -5 0 L -2 5 L 6 -6" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* User icon (bottom left) */}
      <g transform="translate(60, 440)">
        <circle cx="0" cy="0" r="22" fill="#3B82F6" opacity="0.15" />
        <circle cx="0" cy="-3" r="6" fill="none" stroke="#3B82F6" strokeWidth="2" />
        <path d="M -8 10 Q 0 4 8 10" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" />
      </g>

      {/* Connecting lines */}
      <path d="M 85 160 Q 100 165 115 170" fill="none" stroke="#4F46E5" strokeWidth="1" strokeDasharray="3,3" opacity="0.3" />
      <path d="M 720 235 Q 710 260 700 285" fill="none" stroke="#F59E0B" strokeWidth="1" strokeDasharray="3,3" opacity="0.3" />
    </svg>
  );
};

export default HeroIllustration;
